<template>
  <div class="p-9">
    <bim-text type="main" class="mb-4">
      {{ $bimTranslate('noticeTrialHasExpired.title', activeLang) }}
    </bim-text>
    <bim-text type="medium" class="mb-6">
      {{ $bimTranslate('noticeTrialHasExpired.body', activeLang) }}
    </bim-text>
    <div class="d-flex">
      <bim-button size="s" @click="getATariff" class="mr-1">
        {{ $bimTranslate('noticeTrialHasExpired.ok', activeLang) }}
      </bim-button>
      <bim-button size="s" @click="$emit('close')" class="ml-auto">
        {{ $bimTranslate('noticeTrialHasExpired.cancel', activeLang) }}
      </bim-button>
    </div>
  </div>
</template>

<script>
import bimText from '@/components/text/bimText/bimText'
import bimButton from '@/components/form/bimButton/bimButton'

export default {
  name: 'NoticeTrialHasExpired',
  components: {
    bimText,
    bimButton
  },
  props: {
    activeLang: {
      type: String,
      default: 'ru',
      validator (value) {
        return ['ru', 'en'].indexOf(value) !== -1
      }
    },
  },
  methods: {
    getATariff () {
      this.$emit('open-request-popup')
      this.$emit('close')
    }
  }
}
</script>
